import { register } from '@shopify/theme-sections'
import '../../styles/sections/section-process-dropdown.scss'
import $ from 'jquery'
import 'slick-carousel'

export default register(`section-process-dropdown`, {
  onLoad() {
    document
        .querySelectorAll(`[data-section-type="section-process-dropdown"] .single-accordion .accordion-trigger`)
        .forEach(trigger => {
            trigger.addEventListener(`click`, event => {
                                                let trigger_target = document.getElementById(trigger.dataset.target)
                                trigger.classList.toggle(`active`)
                trigger_target.classList.toggle(`visible`)
            })
        })
    $(`.steps-block-slider`).not(`.slick-initialized`).each(function() {
      $(this).slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            responsive: [
              {
                breakpoint: 868,
                settings: {
                  slidesToShow: 1,
                  arrows: true,
                  dots: true
                }
              }
            ]
          }
      )
    })
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})







